
import store from "@continente/vue/components/store";
import { deliveryScheduleSlider } from "../../utilities/carouselSlickConfig";
import { getSVGIcon } from "../../utilities/globalUtilities";
import DeliveryScheduleComponent from "@continente/vue/components/DeliveryScheduleComponent";

/**
 * @function
 * @description - Initialize the checkout delivery slots Vue component
 * @param {String} el - Delivery slot element selector
 * @param {Object} deliverySlotsData - delivery slots data
 * @param {Boolean} loadMoreSlots - loaded more slots
 */
const initVueDeliverySchedule = (el, res, loadMoreSlots) => {
    const shipmentDeliverySlots = res.shipmentDeliverySlots;
    if (!shipmentDeliverySlots || shipmentDeliverySlots.length == 0) { return; }

    if (!loadMoreSlots) {
        // For each shipment ID, create the data that will be passed into the vuex store
        const shipmentObject = {
            "shipmentID": shipmentDeliverySlots.shipmentId,
            "activeIndex": 0,
            "chosenWeekdayShort": "-",
            "chosenDay": "-",
            "chosenMonth": "-",
            "chosenInterval": "-",
            "chosenPrice": "-",
            "chosenSlotId": null,
            "originalPrice": "",
            "discountPrice": "",
            "shipmentDeliverySlots" : shipmentDeliverySlots
        };
    
        store.commit("setShipmentData", shipmentObject);

        loadMoreSlots = res.loadedMoreSlots;
    }
    
    store.commit("setShipmentDeliverySlots", shipmentDeliverySlots);

    const data = () => {
        return {
            shipmentDeliverySlots,
            loadingMoreSlots: loadMoreSlots,
            currentSlide: 0,
            settings: deliveryScheduleSlider(shipmentDeliverySlots.groupedDeliverySlots?.length, shipmentDeliverySlots.isNonScheduled, loadMoreSlots),
            prevArrow: getSVGIcon("icon-arrow-left"),
            nextArrow: getSVGIcon("icon-arrow-right"),
            entregaZero: getSVGIcon("icon-entrega-zero"),
            checkmarkIcon: getSVGIcon("icon-checkmark", ".svg-icons-container"),
            informationIcon: getSVGIcon("icon-info-shipments"),
            resources: res.resources,
            hasShippingCoupon: res.hasShippingCoupon,
            currentShipmentContainer: document.querySelector(`.shipping-delivery-slot[data-shipment-id="${shipmentDeliverySlots.shipmentId}"]`),
            shipmentID: shipmentDeliverySlots.shipmentId,
            arrowUpDown: getSVGIcon("icon-arrow-down")
        };
    };

    new DeliveryScheduleComponent({el, store, data });
};

export { initVueDeliverySchedule };
